export const auth = {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
}
